import { ApiController } from '@/services/ApiController';
import { ApiRoutes } from '@/enums/api/ApiRoutes';
import { AxiosResponse } from 'axios';
import { DeliveryRegionFields } from '@/interfaces/DeliveryRegion';

export default class DeliveryRegionAPI {
    public static async getAll() {
        let deliveryRegions;

        try {
            deliveryRegions = (await ApiController.get(ApiRoutes.deliveryRegion.get)) as AxiosResponse;
        } catch (e) {
            return Promise.reject(e);
        }

        return Promise.resolve(deliveryRegions);
    }

    public static async getById(deliveryRegionId: string) {
        let deliveryRegion;

        try {
            deliveryRegion = (await ApiController.get(
                ApiRoutes.deliveryRegion.getById(deliveryRegionId),
            )) as AxiosResponse;
        } catch (e) {
            return Promise.reject(e);
        }

        return Promise.resolve(deliveryRegion);
    }

    public static async update(deliveryRegionId: string, deliveryRegionInfo: DeliveryRegionFields) {
        let deliveryRegion;

        const request = {
            data: {
                type: 'delivery_regions',
                id: deliveryRegionId,
                attributes: {
                    name: deliveryRegionInfo.name,
                },
            },
        };

        try {
            deliveryRegion = (await ApiController.patch(
                ApiRoutes.deliveryRegion.update(deliveryRegionId),
                request,
            )) as AxiosResponse;
        } catch (e) {
            return Promise.reject(e);
        }

        return Promise.resolve(deliveryRegion);
    }

    public static async create(deliveryRegionInfo: DeliveryRegionFields) {
        let deliveryRegion;

        const request = {
            data: {
                type: 'delivery_regions',
                attributes: {
                    name: deliveryRegionInfo.name,
                },
            },
        };

        try {
            deliveryRegion = (await ApiController.post(
                ApiRoutes.deliveryRegion.create,
                request,
            )) as AxiosResponse;
        } catch (e) {
            return Promise.reject(e);
        }

        return Promise.resolve(deliveryRegion);
    }

    public static async delete(deliveryRegionId: string) {
        try {
            await ApiController.delete(ApiRoutes.deliveryRegion.delete(deliveryRegionId));
        } catch (e) {
            return Promise.reject(e);
        }

        return Promise.resolve();
    }
}
